import instance from "./axios.base";

const getPunishmentList = async () => {
  const res = await instance.get("/punishmenttype");
  return res.data;
};

export { getPunishmentList };
